var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['zm-skeleton__item', `zm-skeleton__${_vm.variant}`]},[(_vm.variant === 'image')?_c('img-placeholder'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }